<template>
  <Sidebar />
  <Content>
    <div class="messaging-wrap">
      <aside class="messaging-sidebar" :class="{'hide-navi': $ProjectName === 'cj'}">
        <Navi v-if="$ProjectName !== 'cj'" :menu="menu" />
        <slot name="sidebar"></slot>
      </aside>
      <section class="messaging-main">
        <slot name="main"></slot>
      </section>
    </div>
  </Content>
</template>

<script setup>
import Sidebar from '@/components/Sidebar.vue';
import Content from '@/components/ui/Content.vue';
import Navi from '@/components/Navi.vue';
import { ref, computed } from 'vue';
import Store from '@/store/index.js';


const permission_mes= computed(()=>{
  return Store.state.user_data?.permission_list?.messagesAndAnnouncements;
});

const menu =computed(()=>{
  return [
    {
      text: 'Announcements',
      to: '/messaging/announcements',
      meta: 'announcements',
      show: permission_mes.value?.manageAnnouncements.permission !== 0
    },
    {
      text: 'Chats',
      to: '/messaging/chats',
      meta: 'chats',
      show: permission_mes.value?.manageMessaging.permission !== 0
    },
  ]
});



</script>

<style lang="scss">
.page-messaging-chats-detail,
.page-messaging-announcements-detail,
.page-messaging-announcements,
.page-messaging-chats {
  .admin-content {
    overflow: hidden;
  }
}

.messaging-wrap {
  display: flex;
  height: 100%;
  overflow: hidden;
  width: 100%;

  .ui-navi ul li a {
    color: var(--black-75);

    &:hover {
      color: var(--black-90);
    }

    &.router-link-active, 
    &.router-link-exact-active, 
    &.link-selected {
      color: var(--black-90);
    }
  }
}

.messaging-sidebar {
  width: 350px;
  height: 100%;
  overflow-y: auto;
  border-right: 1px solid var(--black-10);

  &.hide-navi {
    padding-top: 48px;
  }

  .ui-navi {
    padding: 16px 32px;
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 5;
    background-color: var(--white);

    ul {
      justify-content: space-around;
      display: grid;
      grid-template-columns: 1fr 1fr;
      li{
        span {
          text-align: center;
          width: 100%;
        }
      }
    }
  }
}

.messaging-main {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  margin: 0 16px;
}
</style>
